import classNames from 'classnames';
import moment from 'moment';
import React, { Component } from 'react';
// import * as Constants from '../../utilities/constants';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import Modal, { DefaultModalParams } from '../SubComponents/Modal/Modal';
import GCModal from '../SubComponents/Modal/GCModal';
import PriceBar from '../SubComponents/PriceBar/PriceBarContainer';
import Button from '../SubComponents/CustomButton/CustomButton';
// import Slider from '../SubComponents/Slider/Slider';
// import * as Recaptcha from 'react-recaptcha';

import { addCustomTagEvent } from '../../utilities/customTag';
import { ReCaptcha } from 'react-recaptcha-v3';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import './Checkout.css';

import PhoneField from '../PhoneField/PhoneField';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ReactTooltip from 'react-tooltip';

import {
  removeGiftCard,
  resetCurrentAmount
} from "../../actions/giftCard";

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

export const InputStep = Object.freeze({
  None: 0,
  Checking: 1,
  FoundBetter: 2,
  FoundNotBetter: 3,
  NotFound: 4,
  FoundNotApplied: 5,
  FoundNotAvailable: 6,
  ReqsNotMet: 7,
  FoundCard: 8,
  NotFoundCard: 9,
  FoundAlreadyHave: 10,
  ChargeOfZero: 11,
  CardNoBalance: 12,
  CurrencyMismatch: 13,
  CardFoundNotAvailable: 14,
  ThresholdNotMet: 15,
  MoreCardsThanStations: 16,
  PinNeeded: 17,
  LoadingBalance: 18
});

export const typingTimeout = 2000;

const mapStateToProps = (state) => {
  return {
    terms_and_conditions_url: state.bookingLocation.selectedLocation.terms_and_conditions_url,
    country: state.bookingLocation.selectedLocation.country,
    giftCards: state.giftCard.array
  };
};
const mapDispatchToProps = (dispatch) => ({
  removeGiftCard: (giftCardNumber, amount) =>
    dispatch(removeGiftCard(giftCardNumber, amount)),

  resetCurrentAmount: () => dispatch(resetCurrentAmount())
});

export default connect(mapStateToProps, mapDispatchToProps)(class Checkout extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showHeader: true,
      modalOpen: false,
      modalParams: DefaultModalParams,
      windowWidth: window.outerWidth,
      windowHeight: window.outerHeight,
      orderOfInputs: ['firstName', 'lastName', 'email', 'email2', 'phone', 'promo', 'vcard'],
      emailMask: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
      promoStep: InputStep.None,
      vcardTouched: false,
      vcardStep: InputStep.None,
      vcardAmount: 0,
      onFinalStep: false,
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handlePromoKeyUp = this.handlePromoKeyUp.bind(this);
  }

  tryAddPlus(string) {
    if (!string) return "";
    else if (string.charAt(0) === '+') return string;
    else return `+${string}`;
  }
  componentDidMount() {
    if (this.props.isCostaRica) {
      this.props.getProvincias();
    }

    if (localStorage.getItem('customerData') !== null) {
      const info = JSON.parse(localStorage.getItem('customerData'));

      this.props.setUsedLocalStorage();
      this.props.setFirstName(info.first_name);
      this.props.setLastName(info.last_name);
      this.props.setEmail(info.email);
      this.props.setEmail2(info.email2);
      this.props.setPhone(this.tryAddPlus(info.phone));
      console.log(info.customer_card_number);
      this.props.setCustomerCardNumber(info.customer_card_number);
    }

    addCustomTagEvent({
        event: 'InitiateCheckout',
        category: 'Cart',
        label: 'Checkout'
    });

    document.documentElement.style.overflowY = 'hidden';
    this.promoTypingTimer = null;
    this.vcardTypingTimer = null;
    for (let ref in this.refs) {
      this.refs[ref].inputElement.onkeypress = e => this.handleKeyPress(e, this.refs[ref]);
    }
    if (!this.props.isExtraLife) {
      this.refs['promo'].inputElement.onkeyup = e => this.handlePromoKeyUp(e, this.refs['promo']);
      this.refs['promo'].inputElement.onpaste = e => this.handlePromoKeyUp(e, this.refs['promo']);
    }

  }

  componentWillUnmount() {
    document.documentElement.style.overflowY = 'visible';
  }

  validate() {
    const firstName = this.props.firstName ? true : false;
    const lastName = this.props.lastName ? true : false;
    const email = this.state.emailMask.test(this.props.email);
    const email2 = this.state.emailMask.test(this.props.email2) && this.props.email.toLowerCase() === this.props.email2.toLowerCase();
    const phone = this.props.phone !== undefined && isString(this.props.phone) && isValidPhoneNumber(this.props.phone);
    const promo = this.state.promoStep !== InputStep.Checking;
    const hasAcceptedTerms = this.props.hasAcceptedTerms;
    const alignetAddress = this.validateAlignetAddress();
    const alignetPhone = this.validateAlignetPhone();
    return firstName && lastName && email && email2 && phone && promo && hasAcceptedTerms && alignetAddress && alignetPhone;
  }

  validateAlignetAddress() {
    return (
      this.props.provinciaId === ''
      && this.props.cantonId === ''
      && this.props.distritoId === ''
      && this.props.barrioId === ''
      && this.props.direccion === ''
    ) || (
        this.props.provinciaId !== ''
        && this.props.cantonId !== ''
        && this.props.distritoId !== ''
        && this.props.barrioId !== ''
        && this.props.direccion !== ''
      );
  }

  validateAlignetPhone() {
    return (
      this.props.areaTelefono === ''
      && this.props.numTelefono === ''
    ) || (
        this.props.areaTelefono !== ''
        && this.props.numTelefono !== ''
      );
  }

  handleKeyPress(e, field) {
    const { orderOfInputs } = this.state;
    if (e.keyCode === 13) { // enter
      e.preventDefault();
      let nextIndex = orderOfInputs.indexOf(field.props.id) + 1;
      if (nextIndex < orderOfInputs.length) {
        let next = this.refs[orderOfInputs[nextIndex]];
        if (next && next.inputElement && next.inputElement.tagName === 'INPUT') next.inputElement.focus();
      }
    }
  }

  handlePromoKeyUp(e, field) {
    clearTimeout(this.promoTypingTimer);
    this.promoTypingTimer = setTimeout(() => {
      if (this.props.promo && this.props.promo !== '') {
        this.props.trySelectPromo(this.props.promo, false)
          .then(result => {
            this.props.setPromo(this.props.promo);
            this.setState({ promoStep: InputStep.FoundBetter });
          })
          .catch(promostep => {
            if (promostep === InputStep.FoundNotBetter) {
              this.openModal({
                title: this.props.languageObj.promo_code.promo_code_title,
                content: this.props.languageObj.promo_code.promo_code_content,
                acceptText: this.props.languageObj.promo_code.promo_code_accept,
                cancelText: this.props.languageObj.promo_code.promo_code_accept_but_another_one,
                isConfirm: true,
                onAccept: () => this.setState({ promoStep: InputStep.FoundNotApplied }),
                onCancel: () => this.setState({ promoStep: InputStep.FoundNotApplied })
              });
            }
            this.setState({ promoStep: promostep });
          });
      }
    }, typingTimeout);
  }

  handleFirstNameChange = e => {
    this.props.setFirstName(e.currentTarget.value);
  }

  handleLastNameChange = e => {
    this.props.setLastName(e.currentTarget.value);
  }

  handleEmailChange = e => {
    this.props.setEmail(e.currentTarget.value);
  }

  handleEmail2Change = e => {
    this.props.setEmail2(e.currentTarget.value);
  }

  handlePhoneChange = e => {
    this.props.setPhone(e);
  }

  handleCusNumberChange = e => {
    this.props.setCusNumber(e.currentTarget.value);
  }

  handleProvinciaId = e => {
    this.props.setProvinciaId(e.currentTarget.value);
    this.props.getCantons(e.currentTarget.value);
  }

  handleCantonId = e => {
    this.props.setCantonId(e.currentTarget.value);
    this.props.getDistritos(e.currentTarget.value);
  }

  handleDistritoId = e => {
    this.props.setDistritoId(e.currentTarget.value);
    this.props.getBarrios(e.currentTarget.value);
  }

  handleBarrioId = e => {
    this.props.setBarrioId(e.currentTarget.value);
  }

  handleDireccion = e => {
    this.props.setDireccion(e.currentTarget.value);
  }

  handleTipoIdent = e => {
    this.props.setTipoIdent(e.currentTarget.value);
  }

  handleTipoDoc = e => {
    this.props.setTipoDoc(e.currentTarget.value);
  }

  handleAreaTelefono = e => {
    let val = e.currentTarget.value;

    if (!isNaN(val) && val.length < 10) {
      this.props.setAreaTelefono(val);
    } else {
      e.currentTarget.value = this.props.areaTelefono
    }
  }

  handleNumTelefono = e => {
    let val = e.currentTarget.value;

    if (!isNaN(val) && val.length < 10) {
      this.props.setNumTelefono(val);
    } else {
      e.currentTarget.value = this.props.numTelefono
    }
  }

  handleCorreo = e => {
    this.props.setCorreo(e.currentTarget.value);
  }

  handleFullName = e => {
    this.props.setFullName(e.currentTarget.value);
  }

  handleAcceptTermsChange = e => {
    this.props.setHasAcceptedTerms(e.currentTarget.checked);
  }

  handleHasYoungChildrenChange = e => {
    this.props.setHasYoungChildren(e.currentTarget.checked);
  }

  handlePromoChange = e => {
    if (this.state.promoStep === InputStep.FoundBetter) this.props.resetDiscount();
    if (e.currentTarget.value !== '') this.setState({ promoStep: InputStep.Checking });
    else this.setState({ promoStep: InputStep.None });
    this.props.setPromo(e.currentTarget.value.toUpperCase());
  }

  onClickGiftCards = e => {
    this.openModalGC({
      title: this.props.languageObj.gift_card.gift_card_title,
      acceptText: this.props.languageObj.gift_card.gift_card_accept,
      cancelText: '',
      isConfirm: false,
      label: this.props.languageObj.gift_card.gift_card_label,
      id: 'vcard',
      ref: 'vcard',

      // Points stuff
      pointsTitle: this.props.languageObj.gift_card.points_card_title,
      pointsLabel: this.props.languageObj.gift_card.points_card_label,
      pointsLoginDescription: this.props.languageObj.gift_card.points_login_description,
      pointsRefundWarning: this.props.languageObj.gift_card.points_refund_warning,
      pointsId: 'points',
      pointsRef: 'points',
      googleButton: this.props.languageObj.gift_card.points_google_button,
      facebookButton: this.props.languageObj.gift_card.points_facebook_button,
      accountRedirect: this.props.languageObj.gift_card.points_redirect,
      loginFailTextPart1: this.props.languageObj.gift_card.points_failed_login_text_part_1,
      loginFailTextPart2: this.props.languageObj.gift_card.points_failed_login_text_part_2,
    });
  }

  handleInputFocused = (index) => {
    // if (window.innerWidth < Constants.landscapeWidth) {
    //   this.setState({
    //     showHeader: false
    //   });
    //   window.setTimeout(() => {
    //     this.slider && this.slider.scrollToChild(index, 5);
    //   }, 500);
    // }
  }

  handleInputBlurred = () => {
    this.setState({
      showHeader: true
    });
  }

  determineEarliestTimeslot = () => {
    const fullStationState = this.props.fullStationStateObj;
    const selectedTimeslots = Object.entries(fullStationState.selectedStations).map(([selectedTimeslot, _selectedItem]) => {
        return fullStationState.stationsData.timeslots.filter((timeslot) => {
            return selectedTimeslot == timeslot.timeslotId
        })[0].moment
    });
    return selectedTimeslots.reduce((prevTimeslot, curTimeslot) => prevTimeslot.isBefore(curTimeslot) ? prevTimeslot : curTimeslot);
  }

  verifyDetails = () => {

    const earliestTimeslot = this.determineEarliestTimeslot();

    const description = `${this.props.languageObj.checkout_modal.confirm}
    \n${this.props.languageObj.checkout_modal.location} ${this.props.locationName.toLocaleUpperCase()}
    \n${this.props.languageObj.checkout_modal.date} ${moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
    \n${this.props.languageObj.checkout_modal.booking_start_time} ${earliestTimeslot.format('LT')}
    \n${this.props.languageObj.checkout_modal.your_arrival_time} ${earliestTimeslot.subtract(15, 'minutes').format('LT')} ${this.props.languageObj.checkout_modal.minutes_early}`;

    this.openModal({
      title: this.props.languageObj.checkout_modal.almost,
      content: description,
      acceptText: this.props.languageObj.checkout_modal.yes,
      cancelText: this.props.languageObj.checkout_modal.no,
      isConfirm: true,
      onAccept: () => this.onClickNext()
    });
  }

  onClickNext = async () => {
    const valid = this.validate();

    addCustomTagEvent({
        event: 'CheckoutNextEvent',
        category: 'Cart',
        label: 'Checkout',
        checkoutDetails: {
            valid: valid
        }
    });

    if (valid) {
      this.setState({
        onFinalStep: true
      })
      this.recaptcha.execute();
      // Moved to onCaptchaResponse
      localStorage.removeItem('customerInfo');
    }
  }

  onClickPrev = () => {
    addCustomTagEvent({
        event: 'CheckoutBackEvent',
        category: 'Cart',
        label: 'Checkout'
    });
    this.props.giftCards.forEach(card => {
      this.props.removeGiftCard(card.giftcard_number, card.amount_to_charge);
    });
    this.props.resetCurrentAmount();
    this.props.expireCaptcha();
    this.props.transitionBack().catch((error) => {
      console.error('Failed to go back to cart: ' + error);
    });
  }

  onCaptchaExpired = () => {
    this.props.expireCaptcha();
    this.recaptcha.execute();
  }

  onCaptchaResponse = (response) => {
    this.props.completeCaptcha(response);
    if (this.state.onFinalStep) {
      this.props.transitionForward()
        .catch((error) => {
          console.error('Failed to save checkout and continue: ' + error);
          this.openModal({
            title: this.props.languageObj.click_next.next_title,
            content: this.props.languageObj.click_next.next_content,
            acceptText: this.props.languageObj.click_next.next_accept,
            cancelText: '',
            isConfirm: false,
            onAccept: () => this.props.resetApp()
          });
        });
    }
  }

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  }

  onCloseModalGC = () => {
    this.setState({
      modalOpenGC: false
    });
  }

  openModal = (params) => {
    this.setState({
      modalOpen: true,
      modalParams: params
    });
  }

  openModalGC = (params) => {
    this.setState({
      modalOpenGC: true,
      modalParamsGC: params
    });
  }

  toggleGTIReceipt = (event) => {

    if (!event.target.checked) {
      this.props.resetGTI();
    }

    this.props.toggleGTIReceipt(event.target.checked);
  }

  getReceiptTypeDropdown = () => {
    if (this.props.GTIReceipt) {
      return (
        <div className='TextField TextField--45 TextField--cusnumber select-padding'>
          <div className="TextField-label">TIPO DOC</div>
          <select
            value={this.props.tipoDoc}
            onChange={this.handleTipoDoc}
            className="TextField-input GTI-drop-down-remove-padding">

            <option value="1">Factura</option>
            <option value="4">Tiquete</option>

          </select>
        </div>
      );
    }
  }

  generateProvinciaOptions = () => {
    let options = [];

    options.push(
      <option
        key="-1"
        value=""
        disabled={false}>
        Seleccionar...
      </option>
    )

    for (let key in this.props.provincia) {
      options.push(
        <option
          key={key}
          value={this.props.provincia[key].provincia_id}>
          {this.props.provincia[key].provincia_name}
        </option>
      )
    }

    return options;
  }

  getProvinciaDropdown = () => {
    const required = !this.validateAlignetAddress() && this.props.provinciaId === '';
    const label = `PROVINCIA`;
    if (this.props.provincia !== '') {
      return (
        <div className={`TextField TextField--45 select-padding ${(required ? 'TextField--error' : '')}`}>
          <div className="TextField-label">
            {label}
            {required && (
              <span className={'TextField-required'}>{' *'}</span>
            )}
          </div>
          <select
            value={this.props.provinciaId}
            onChange={this.handleProvinciaId}
            className="TextField-input GTI-drop-down-remove-padding">

            {this.generateProvinciaOptions()}

          </select>
        </div>
      );
    } else return null;
  }

  generateCantonOptions = () => {
    let options = [];

    options.push(
      <option
        key="-1"
        value=""
        disabled={false}>
        Seleccionar...
      </option>
    )

    for (let key in this.props.cantons) {
      options.push(
        <option
          key={key}
          value={this.props.cantons[key].canton_id}>
          {this.props.cantons[key].canton_name}
        </option>
      )
    }

    return options;
  }

  getCantonDropdown = () => {
    const required = !this.validateAlignetAddress() && this.props.cantonId === '';
    const label = `CANTON`;
    return (
      <div className={`TextField TextField--45 select-padding ${(required ? 'TextField--error' : '')}`}>
        <div className="TextField-label">
          {label}
          {required && (
            <span className={'TextField-required'}>{' *'}</span>
          )}
        </div>
        <select
          value={this.props.cantonId}
          onChange={this.handleCantonId}
          className="TextField-input GTI-drop-down-remove-padding">

          {this.generateCantonOptions()}

        </select>
      </div>
    );
  }

  generateDistritoOptions = () => {
    let options = [];

    options.push(
      <option
        key="-1"
        value=""
        disabled={false}>
        Seleccionar...
      </option>
    )

    for (let key in this.props.distritos) {
      options.push(
        <option
          key={key}
          value={this.props.distritos[key].distrito_id}>
          {this.props.distritos[key].distrito_name}
        </option>
      )
    }

    return options;
  }

  getDistritoDropdown = () => {
    const required = !this.validateAlignetAddress() && this.props.distritoId === '';
    const label = `DISTRITO`;
    return (
      <div className={`TextField TextField--45 select-padding ${(required ? 'TextField--error' : '')}`}>
        <div className="TextField-label">
          {label}
          {required && (
            <span className={'TextField-required'}>{' *'}</span>
          )}
        </div>
        <select
          value={this.props.distritoId}
          onChange={this.handleDistritoId}
          className="TextField-input GTI-drop-down-remove-padding">

          {this.generateDistritoOptions()}

        </select>
      </div>
    );
  }

  generateBarrioOptions = () => {
    let options = [];

    options.push(
      <option
        key="-1"
        value=""
        disabled={false}>
        Seleccionar...
      </option>
    )

    for (let key in this.props.barrios) {
      options.push(
        <option
          key={key}
          value={this.props.barrios[key].barrio_id}>
          {this.props.barrios[key].barrio_name}
        </option>
      )
    }

    return options;
  }

  getBarrioDropdown = () => {
    const required = !this.validateAlignetAddress() && this.props.barrioId === '';
    const label = `BARRIO`;
    return (
      <div className={`TextField TextField--45 select-padding ${required ? 'TextField--error' : ''}`}>
        <div className="TextField-label">
          {label}
          {required && (
            <span className={'TextField-required'}>{' *'}</span>
          )}
        </div>
        <select
          value={this.props.barrioId}
          onChange={this.handleBarrioId}
          className="TextField-input GTI-drop-down-remove-padding">

          {this.generateBarrioOptions()}

        </select>
      </div>
    );
  }

  getTipoIdentDropdown = () => {
    return (
      <div className={`TextField TextField--45 select-padding`}>
        <div className="TextField-label">TIPO IDENT</div>
        <select
          value={this.props.tipoIdent}
          onChange={this.handleTipoIdent}
          className="TextField-input GTI-drop-down-remove-padding">

          <option value="">Seleccionar...</option>
          <option value="1">CEDULA FÍSICA</option>
          <option value="2">CEDULA JURÍDICA</option>
          <option value="3">DIMEX</option>
          <option value="4">NITE</option>
          <option value="10">EXTRANJERA</option>
        </select>
      </div>
    );
  }

  renderReceiptFields = () => {
    if (this.props.GTIReceipt) {
      return (
        <React.Fragment>

          {this.getTipoIdentDropdown()}

          {this.renderTextField({
            label: this.props.languageObj.render.customer_number_label,
            id: '',
            ref: 'cusnumber',
            name: 'cusnumber',
            required: false,
            mask: false,
            value: this.props.cusNumber,
            handleOnChange: this.handleCusNumberChange,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}


          {this.renderTextField({
            label: "NOMBRE COMPLETO",
            id: 'nombreCompleto',
            ref: 'fullName',
            name: 'fullName',
            required: false,
            mask: false,
            value: this.props.fullName,
            handleOnChange: this.handleFullName,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}

          {this.getProvinciaDropdown()}
          {this.getCantonDropdown()}
          {this.getDistritoDropdown()}
          {this.getBarrioDropdown()}

          {this.renderTextField({
            label: "DIRECCION",
            id: '',
            ref: 'direccion',
            name: 'direccion',
            required: !this.validateAlignetAddress() && this.props.direccion === '',
            requiredOutline: !this.validateAlignetAddress() && this.props.direccion === '',
            mask: false,
            value: this.props.direccion,
            handleOnChange: this.handleDireccion,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}

          {this.renderTextField({
            label: "AREA TELEFONO",
            id: '',
            ref: 'areaTelefono',
            name: 'areaTelefono',
            required: !this.validateAlignetPhone() && this.props.areaTelefono === '',
            requiredOutline: !this.validateAlignetPhone() && this.props.areaTelefono === '',
            mask: false,
            value: this.props.areaTelefono,
            handleOnChange: this.handleAreaTelefono,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}

          {this.renderTextField({
            label: "NUM TELEFONO",
            id: '',
            ref: 'numTelefono',
            name: 'numTelefono',
            required: !this.validateAlignetPhone() && this.props.numTelefono === '',
            requiredOutline: !this.validateAlignetPhone() && this.props.numTelefono === '',
            mask: false,
            value: this.props.numTelefono,
            handleOnChange: this.handleNumTelefono,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}

          {this.renderTextField({
            label: "CORREO",
            id: '',
            ref: 'correo',
            name: 'correo',
            required: false,
            mask: false,
            value: this.props.correo,
            handleOnChange: this.handleCorreo,
            handleOnFocus: this.handleInputFocused.bind(4),
            autoComplete: 'off'
          })}

        </React.Fragment>
      )
    }

    return null;
  }

  renderGTIFields = () => {
    if (this.props.isCostaRica) {

      return (
        <React.Fragment>
          <div style={{ width: "100%" }}>

            <div className="gti-center-receipt">
              Gti Receipt?
            </div>

            <div className="gti-center-receipt">
              <label className="switch">
                <input type="checkbox" checked={this.props.GTIReceipt} onChange={this.toggleGTIReceipt} />
                <span className="slider"></span>
              </label>
            </div>

            {this.getReceiptTypeDropdown()}
          </div>

          {this.renderReceiptFields()}

        </React.Fragment>
      )
    }

    return null;
  }

  renderTextField = body => {
    let valid = body.value ? true : false;

    if (!body.required) valid = true;
    else if (body.id === 'email') {
      valid = this.state.emailMask.test(body.value);
    }
    else if (body.id === 'email2') {
      valid = this.props.email.toLowerCase() === this.props.email2.toLowerCase() && this.state.emailMask.test(body.value);
    }
    else if (body.id === 'phone') {
      valid = this.props.phone !== undefined && isString(this.props.phone) && isValidPhoneNumber(this.props.phone);
    }
    const showError = this.state[body.id + 'Touched'] && !valid;
    const is30 = body.id === 'email' || body.id === 'email2' || body.id === 'phone'
    const textFieldClasses = classNames('TextField', body.className || '', {
      'TextField--error': showError || body.requiredOutline === true,
      'TextField--30': is30,
      'TextField--45': !is30,
      'TextField--promo': body.id === 'promo',
      'TextField--cusnumber': body.id === 'cusnumber'
    });

    const inputCheck = step => {
      switch (step) {
        case InputStep.None:
          return '';
        case InputStep.Checking:
          return <span className={'TextField-inputCheck--checking'}>{this.props.languageObj.input_check.checking}</span>;
        case InputStep.FoundBetter:
          return <span className={'TextField-inputCheck--green'}>{this.props.languageObj.input_check.promo_code_applied}</span>;
        case InputStep.FoundNotBetter:
          return <span className={'TextField-inputCheck--orange'}>{this.props.languageObj.input_check.promo_code_found}</span>;
        case InputStep.NotFound:
          return <span className={'TextField-inputCheck--red'}>{this.props.languageObj.input_check.invalid_promo_code}</span>;
        case InputStep.FoundNotApplied:
          return <span className={'TextField-inputCheck--blue'}>{this.props.languageObj.input_check.promo_code_not_applied}</span>;
        case InputStep.FoundNotAvailable:
          return <span className={'TextField-inputCheck--orange'}>{this.props.languageObj.input_check.no_more_uses}</span>;
        case InputStep.ReqsNotMet:
          return <span className={'TextField-inputCheck--orange'}>{this.props.languageObj.input_check.requirements_not_met}</span>;
        default:
          return '';
      }
    }

    return (
      <div className={textFieldClasses}>
        <div className={'TextField-label'}>
          {body.label}
          {body.required && (
            <span className={'TextField-required'}>{' *'}</span>
          )}
        </div>
        <MaskedInput
          className={'TextField-input'}
          type={body.type || 'text'}
          name={body.name}
          id={body.id}
          ref={body.ref}
          value={body.value}
          onFocus={() => body.handleOnFocus}
          onBlur={() => {
            this.setState({ [body.id + 'Touched']: true });
            this.handleInputBlurred();
          }}
          onChange={e => { body.handleOnChange(e); }}
          autoFocus={body.autoFocus ? true : false}
          mask={body.mask}
          placeholder={body.placeholder}
          guide={false}
          style={{ textTransform: body.id === 'promo' ? 'uppercase' : '' }}
          autoComplete={body.autoComplete}
        />
        <div className={'TextField-errorMessage'} style={{ height: '20px' }}>
          {showError ? body.errorMessage : ''}
          {body.id === 'promo' ? inputCheck(this.state.promoStep) : ''}
        </div>
      </div>
    );
  }

  renderCheckboxLink = (acceptLabel, itemLink, acceptItem) => {
    return (
      <div className={'CheckboxLink'}>
        {acceptLabel}<a style={{ "marginLeft": "5px", "marginRight": "0" }} href={itemLink} target="_blank" rel="noopener noreferrer">{acceptItem}</a>
      </div>
    )
  }

  renderCheckboxNotLink = (acceptLabel) => {
    return (
      <div className={'CheckboxLink'}>
        {`${acceptLabel}`}
      </div>
    )
  }

  renderCheckBox = (body, variablePadding) => {
    let valid = body.value ? true : false;
    if (!body.required) valid = true;
    const showError = this.state[body.id + 'Touched'] && !valid;
    const checkBoxClasses = classNames('CheckBox-span', body.className || '', {
      'CheckBox--error': showError
    });
    const chkbxStyle = {
      "paddingTop": '12px',
      "paddingBottom": (variablePadding) ? ((this.props.discountExists) ? "60px" : "24px") : '0px',
      "display": "flex",
      "flex-direction": "row"
    }
    return (
      <div className={'CheckBox-div'} style={chkbxStyle}>
        <label className={'CheckBox-label'}>
          <input
            className={'CheckBox-input'}
            type="checkbox"
            defaultChecked={body.value}
            onChange={e => { body.handleOnChange(e); }}
            onBlur={() => {
              this.setState({ [body.id + 'Touched']: true });
            }}
          />
          <span
            className={checkBoxClasses}
            style={{ "marginRight": "0", "margin": "0", "verticalAlign": "middle" }}
          ><i className="fas fa-check"></i></span>
        </label>
        <span data-tip={body.hoverLabel} data-multiline={true} className={'CheckboxLink'} style={{ "paddingLeft": "8px" }}>
          <div className={'CheckboxLinkLabel'}>
            {body.itemLink !== '' && this.renderCheckboxLink(body.acceptLabel, body.itemLink, body.acceptItem)}
            {body.itemLink === '' && this.renderCheckboxNotLink(body.acceptLabel)}
          </div>
          {body.required && (
            <span className={'TextField-required'}>{' *'}</span>
          )}
        </span>
      </div>
    );
  }

  render() {
    const headerClasses = classNames({
      'Header--hidden': !this.state.showHeader
    });

    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.locationName.toLocaleUpperCase()}
          subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
          classNames={headerClasses}
          hideOnMobile={true}
        />
        <ReactTooltip />
        <div className="Checkout">
          <div className="Checkout-boxes"> {/*} isCheckout={true} scrollTickInterval={40} ref={(x) => { this.slider = x; }}> */}
            <div className={'Checkout-form'}>
              {this.renderTextField({
                label: this.props.languageObj.render.first_name_label,
                id: 'firstName',
                ref: 'firstName',
                name: 'firstName',
                value: this.props.firstName,
                handleOnChange: this.handleFirstNameChange,
                handleOnFocus: this.handleInputFocused.bind(0),
                required: true,
                autoFocus: this.state.windowWidth > 500 && this.state.windowHeight > 500,
                mask: false,
                errorMessage: this.props.languageObj.render.first_name_error
              })}
              {this.renderTextField({
                label: this.props.languageObj.render.last_name_label,
                id: 'lastName',
                ref: 'lastName',
                name: 'lastName',
                value: this.props.lastName,
                handleOnChange: this.handleLastNameChange,
                handleOnFocus: this.handleInputFocused.bind(1),
                required: true,
                mask: false,
                errorMessage: this.props.languageObj.render.last_name_error
              })}
              {this.renderTextField({
                label: this.props.languageObj.render.email_label,
                id: 'email',
                ref: 'email',
                name: 'email',
                value: this.props.email,
                handleOnChange: this.handleEmailChange,
                handleOnFocus: this.handleInputFocused.bind(2),
                required: true,
                mask: false,
                errorMessage: this.props.languageObj.render.email_error,
                placeholder: this.props.languageObj.render.email_placeholder
              })}
              {this.renderTextField({
                label: this.props.languageObj.render.confirm_email_label,
                id: 'email2',
                ref: 'email2',
                name: 'email2',
                value: this.props.email2,
                handleOnChange: this.handleEmail2Change,
                handleOnFocus: this.handleInputFocused.bind(2),
                required: true,
                mask: false,
                errorMessage: this.props.languageObj.render.confirm_email_error,
                placeholder: this.props.languageObj.render.confirm_email_placeholder
              })}
              <PhoneField
                label={this.props.languageObj.render.phone_label}
                className={'TextField--30 ' || ''}
                placeholder={this.props.languageObj.render.phone_placeholder}
                deferErrors={false}
                required={true}
                value={this.props.phone}
                handleOnChange={this.handlePhoneChange}
                defaultCountry={(this.props.country === 'Costa Rica') ? "CR" : (this.props.country === 'United States') ? "US" : "CA"}
              // handleOnCountryChange={ this.onPhoneCountryChange }
              // labels={(activeLanguage) ? activeLanguage.code : activeLanguage}
              />

              {this.props.isExtraLife ?
                (<div style={{ width: '100%', textAlign: 'center' }}>
                  {this.props.languageObj.extraLifeGiftCardWarning}
                </div>) :
                (<div style={{ width: '100%' }}>
                  {this.renderTextField({
                    label: this.props.languageObj.render.promo_label,
                    id: 'promo',
                    ref: 'promo',
                    name: 'promo_code',
                    required: false,
                    mask: false,
                    value: this.props.promo,
                    handleOnChange: this.handlePromoChange,
                    handleOnFocus: this.handleInputFocused.bind(5),
                    autoComplete: 'off'
                  })}
                </div>)
              }

              {!this.props.isExtraLife && this.props.enableGiftCard && (<span className={'Checkout-GiftCardButton'}>
                <Button
                  text={this.props.languageObj.render.apply_gift_cards}
                  onClick={this.onClickGiftCards}
                />
              </span>
                ||
                <span className={'Checkout-GiftCardButton'}>
                  <Button
                    text={this.props.languageObj.render.apply_just_points}
                    onClick={this.onClickGiftCards}
                  />
                </span>)
              }

              {this.props.isCostaRica ? this.renderGTIFields() : null}

              <div className={'CheckBox-outer'}>
                <div className={'CheckBox-inner'}>
                  {this.renderCheckBox({
                    value: this.props.hasAcceptedTerms,
                    required: true,
                    id: 'hasAcceptedTerms',
                    acceptLabel: this.props.languageObj.render.accept_terms_text,
                    acceptItem: this.props.languageObj.render.terms_and_conditions,
                    itemLink: this.props.terms_and_conditions_url,
                    handleOnChange: this.handleAcceptTermsChange
                  }, false)}

                  {this.renderCheckBox({
                    value: this.props.hasYoungChildren,
                    required: false,
                    id: 'hasYoungChildren',
                    acceptLabel: this.props.languageObj.render.young_children_attending_label,
                    hoverLabel: this.props.languageObj.render.young_children_attending_hover,
                    itemLink: '',
                    handleOnChange: this.handleHasYoungChildrenChange
                  }, true)}
                </div>
              </div>
              <ReCaptcha
                sitekey='6LccEpsUAAAAAMmvR8o6-0zC4D3EWU-A20MTefmI'
                action='checkout_page'
                verifyCallback={this.onCaptchaResponse}
                ref={ref => this.recaptcha = ref}
              />
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modalOpen}
          handleClose={this.onCloseModal}
          {...this.state.modalParams}
          modalType={0}
        />
        <GCModal
          usedLocalStorage={this.props.usedLocalStorage}
          customerCardNumber={this.props.customerCardNumber}
          isOpen={this.state.modalOpenGC}
          handleClose={this.onCloseModalGC}
          fullStationStateObj={this.props.fullStationStateObj}
          {...this.state.modalParamsGC}
        />
        <PriceBar isSubtotal={false} />
        <Footer
          nextName={this.props.languageObj.render.next_name}
          prevName={this.props.languageObj.render.prev_name}
          nextDisabled={this.validate() === false || this.props.captchaCompleted === false || this.props.totalBool === false}
          prevDisabled={false}
          handleClickNext={this.verifyDetails}
          // handleClickNext={this.onClickNext}
          handleClickPrev={this.onClickPrev}
        />
      </div>
    );
  }

})
